'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-2';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0ef';
var svgPathData = ['M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zM176.6 379.1c-1.2-3-.6-6.4 1.7-8.7L302.5 246.1C313.7 235 320 219.8 320 204c0-32.6-26.2-59.1-58.8-59.6l-2.3 0c-14.4-.2-28.3 4.6-39.6 13.6L189 182.2c-3.4 2.8-8.5 2.2-11.2-1.2s-2.2-8.5 1.2-11.2l30.4-24.3c14.1-11.3 31.7-17.3 49.8-17.1l2.3 0C302.8 129 336 162.7 336 204c0 20.1-8 39.3-22.1 53.5L203.3 368 344 368c4.4 0 8 3.6 8 8s-3.6 8-8 8l-160 0c-3.2 0-6.2-1.9-7.4-4.9z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM219.4 157.9c11.2-9 25.2-13.8 39.6-13.6l2.3 0c32.6 .5 58.8 27 58.8 59.6c0 15.8-6.3 31-17.5 42.2L178.3 370.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9l160 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-140.7 0L313.9 257.5C328 243.3 336 224 336 204c0-41.3-33.2-75-74.5-75.6l-2.3 0c-18.1-.3-35.7 5.8-49.8 17.1L179 169.8c-3.5 2.8-4 7.8-1.2 11.2s7.8 4 11.2 1.2l30.4-24.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle2 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;